var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubreddit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 813,
    height: 733,
    viewBox: "0 0 813 733",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 75,
    width: 620,
    height: 608,
    rx: 103,
    fill: "#1491FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220 342.155C220 290.14 262.15 248 314.154 248H387.645C439.66 248 481.8 290.15 481.8 342.155C481.8 394.141 439.65 436.3 387.645 436.3H332.2V481.75C332.2 481.75 220 459.03 220 342.155Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M411.46 452.456C425.473 465.943 444.174 473.465 463.624 473.438H491.15V509.8C491.15 509.8 594 491.624 594 398.124C594 378.148 586.065 358.991 571.942 344.865C557.818 330.739 538.661 322.802 518.686 322.8H498.022C499.64 328.934 500.5 335.376 500.5 342.024C500.5 396.197 462.352 441.47 411.46 452.456Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubreddit);
export default __webpack_public_path__ + "static/media/subreddit.6314b36e229f96caf1075cef58dd1a59.svg";
export { ForwardRef as ReactComponent };